import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { BatchesModel } from "./batches-data-model";

export class BatchesGridModel extends BatchesModel { }

export class BatchesListingModel extends GridModel<BatchesGridModel> { }
export class NotificationGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    searchText: '';
    direction: '';
    column: ''
}